import React from 'react';
import { observer } from 'mobx-react';
import { BusyStore } from 'ui/base/button/store';
import { Theme, ThemedStyles, useStyles } from 'ui/base/theme';
import baseStyles from './switch_input.module.css';
import {
  CheckboxInput as BaseCheckboxInput,
  CheckboxInputProps as BaseCheckboxInputProps,
} from 'ui/base/input';

type SwitchInputStyles = {
  unselected: string;
  selected: string;
  disabledUnselected: string;
  disabledSelected: string;
  checkbox: string;
  loadingIcon: string;
  reserveLoadingIcon: string;
};

const themedStyles: ThemedStyles<SwitchInputStyles> = {
  [Theme.DAYLIGHT]: {
    unselected: baseStyles.daylightUnselectedLabel,
    selected: baseStyles.daylightSelectedLabel,
    disabledUnselected: baseStyles.daylightDisabledUnselectedLabel,
    disabledSelected: baseStyles.daylightDisabledSelectedLabel,
    checkbox: baseStyles.checkbox,
    loadingIcon: baseStyles.loadingIcon,
    reserveLoadingIcon: baseStyles.reserveLoadingIcon,
  },
  [Theme.MIDNIGHT]: {
    unselected: baseStyles.midnightUnselectedLabel,
    selected: baseStyles.midnightSelectedLabel,
    disabledUnselected: baseStyles.midnightDisabledUnselectedLabel,
    disabledSelected: baseStyles.midnightDisabledSelectedLabel,
    checkbox: baseStyles.checkbox,
    loadingIcon: baseStyles.loadingIcon,
    reserveLoadingIcon: baseStyles.reserveLoadingIcon,
  },
};

/* Since the SwitchInput is just a glorified CheckboxInput, we use the same CheckboxStore */
export type SwitchInputProps = Omit<BaseCheckboxInputProps, 'className'>
& {
  busy?: BusyStore | boolean;
  reserveBusyIconArea?: boolean;
};
export const SwitchInput = observer(({ store, busy, reserveBusyIconArea, ...props }: SwitchInputProps) => {
  const styles = useStyles(themedStyles);
  const busyValue = busy instanceof BusyStore ? busy.value : busy;
  if (busyValue) {
    // don't allow clicking while busy
    props.disabled = true;
  }
  return (
    <>
      {busyValue ?
        <div className={styles.loadingIcon}/> :
        reserveBusyIconArea ?
          <div className={styles.reserveLoadingIcon}/> :
          null
      }
      <label className={props.disabled ? (store.value ? styles.disabledSelected : styles.disabledUnselected) : (store.value ? styles.selected : styles.unselected)}>
        <BaseCheckboxInput className={styles.checkbox} store={store} {...props}/>
      </label>
    </>
  );
});
